/**
 * Child Selected Marker
 *
 * Adds 'child-selected' class to <html> element when a child profile is selected.
 * This runs as early as possible to prevent flash of promo cards.
 *
 * CSS rule: html.child-selected .promo-placeholder[data-show-when-child-selected="false"] { display: none !important; }
 */

(function() {
  'use strict';

  // Check localStorage immediately (synchronous)
  function checkChildSelected() {
    try {
      // Check the primary storage key
      const state = localStorage.getItem('kids-sizing-system-state');
      if (state) {
        const parsed = JSON.parse(state);
        // Child is selected if currentChildId is set
        if (parsed.currentChildId && parsed.currentChildId !== '') {
          return true;
        }
      }
    } catch (e) {
      // Silent fail - don't block page load
    }
    return false;
  }

  // Apply class immediately (before DOM ready)
  if (checkChildSelected()) {
    document.documentElement.classList.add('child-selected');
    console.log('[ChildSelectedMarker] Added child-selected class to HTML');
  } else {
    console.log('[ChildSelectedMarker] No child selected');
  }

  // Also listen for state changes and update class dynamically
  function updateChildSelectedClass() {
    if (checkChildSelected()) {
      document.documentElement.classList.add('child-selected');
    } else {
      document.documentElement.classList.remove('child-selected');
    }
  }

  // Listen for state changes
  if (typeof window !== 'undefined') {
    // Listen for custom state change events
    document.addEventListener('stateChanged', function(e) {
      if (e.detail && (e.detail.key === 'currentChildId' || e.detail.key === 'currentChild')) {
        updateChildSelectedClass();
      }
    });

    // Listen for storage events (cross-tab sync)
    window.addEventListener('storage', function(e) {
      if (e.key === 'kids-sizing-system-state') {
        updateChildSelectedClass();
      }
    });
  }
})();
